import { Component, OnInit } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { AppFilter, ConfirmModal, EmailModal } from 'src/modules/shared';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { FinanceService } from '../../../services';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';
declare global {
  interface Window {
    RmPaymentEngine: any;
  }
}
@Component({
  selector: 'app-lot-payment',
  templateUrl: './lot-payment.component.html',
  styleUrls: ['./lot-payment.component.scss'],
})
export class LotPaymentComponent implements OnInit {
  projectId: string;
  pending: boolean;
  baseUrl: string = environment.API_SERVER;
  webUrl: string = environment.WEB;
  purpose: string;
  amount: any = 0;
  beneficiary: string;
  rrr: string;
  description: string;
  address: string;
  name: string;
  phone: string;
  email: string;
  paymentLink: string;
  paymentType: string;
  currencyCode: string;
  docPath: string;
  pendingArr: boolean[] = [];
  invoiceNumber!: string;
  invoice: any;
  invoicePayment: any;
  user;
  filter = new AppFilter({
    sidx: 'walletCreatedDate',
    sord: 'asc',
    _search: false,
  });
  balances: any = [];
  nairaWallet;
  dollarWallet;
  invoiceNo;
  initiatedPaymentId;
  transactionRef;
  internalTransactionRef;
  paymentRedirect: boolean = false;
  paymentComplete: boolean = false;
  redirectUrl: string | null = '/contractor/invoice/list';
  systemRedirect: string | null = null;
  noPayment = false;

  constructor(
    private modalService: SuiModalService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private financeSvc: FinanceService,
    private eWalletServices: EwalletService,
    private router: Router
  ) {
    this.user = JSON.parse(window.localStorage.getItem('user'));
    this.getConfig('REMITA_PAYMENT_REDIRECT');
    this.activatedRoute.queryParams.subscribe((params) => {
      this.invoiceNumber = params['invoiceNumber'];
      this.transactionRef = params['transactionRef'];
      this.systemRedirect = params['path'];
      if (this.invoiceNumber) {
        this.getInvoice(this.invoiceNumber);
        this.getInvoicePayment(this.invoiceNumber);
        this.beneficiary = 'Nigerian Communications Commission';
      } else if (this.transactionRef) {
        this.callStarted();
        this.pending = true;
        this.financeSvc.getPaymentStatus({ id: this.transactionRef }).subscribe(
          (res: any) => {
            this.paymentType =
              res['payment']['paymentDetails']['currencyId'] == 'naira'
                ? 'LOCAL'
                : 'FOREIGN';
            this.purpose = params['purpose'] ? params['purpose'] : 'Fees';
            this.amount = res['amount'];
            this.currencyCode = res['currencyCode'];
            this.beneficiary = 'Nigerian Communications Commision';
            this.rrr = res.payment['transactionRef'];
            this.description = res['payment']['description']
              ? res['payment']['description']
              : res['payment']['paymentDetails']['invoice_description'];
            this.address = res['payment']['paymentDetails']['payers_address'];
            this.name = res['payment']['paymentDetails']['payers_name'];
            this.phone = res['payment']['paymentDetails']['payers_phone'];
            this.email = res['payment']['paymentDetails']['payers_email'];
            this.docPath = res['payment']['detailsDocumentPath'];
            this.paymentLink = res['paymentUrl']
              ? res['paymentUrl']
              : res['payment']['paymentUrl'];
            this.invoiceNo = res['payment']['paymentDetails']['invoice_number'];
            this.initiatedPaymentId = res['payment']['initiatedPaymentId'];
            this.internalTransactionRef =
              res['payment']['internalTransactionRef'];
            setTimeout(() => {
              this.pending = false;
              this.callCompleted();
            }, 2000);
          },
          (error) => {
            this.pending = false;
          }
        );
      } else {
        console.log('here');
        this.projectId = params['id'];
        this.paymentType = params['paymentType'];
        this.purpose = params['purpose'];
        this.amount = params['amount'];
        this.currencyCode = params['currencyCode'];
        this.beneficiary = params['beneficiary'];
        this.rrr = params['rrr'];
        this.description = params['description'];
        this.address = params['address'];
        this.name = params['name'];
        this.phone = params['phone'];
        this.email = params['email'];
        this.docPath = params['docPath'];
        this.paymentLink = params['paymentLink'];
        this.invoiceNo = params['invoiceNo'];
        this.initiatedPaymentId = params['initiatedPaymentId'];
        this.internalTransactionRef = params['internalTransactionRef'];
      }
    });
    this.getBalances(this.filter);
  }

  getBalances(params: any) {
    // Get Balances
    const user = JSON.parse(localStorage.getItem('user'));
    const nccId = user.organizationId.jpaContractor.nccId;
    this.eWalletServices
      .getBalances({
        params: {
          ...params,
          nccId: nccId,
        },
      })
      .subscribe(
        (res) => {
          this.balances = res['rows'];
          this.nairaWallet = this.balances.find(
            (wallet) => wallet.currencyCode === '₦'
          );
          this.dollarWallet = this.balances.find(
            (wallet) => wallet.currencyCode !== '₦'
          );
          this.pending = false;
        },
        (err) => {
          // this.error = err.error;
          this.pending = false;
        }
      );
  }

  payWallet(walllet) {
    this.pending = true;
    // Get Balances
    console.log(this.initiatedPaymentId, 'initiate');
    const user = JSON.parse(localStorage.getItem('user'));
    const nccId = user.organizationId.jpaContractor.nccId;
    let payload = {
      nccId: nccId,
      initiatedPaymentId: this.initiatedPaymentId,
    };

    this.eWalletServices
      .payNonInvoice({
        body: payload,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = true;
          setTimeout(() => {
            this.router.navigate([`/contractor/payment/list`]);
          }, 2000);
        },
        (err) => {
          this.error = true;
          this.pending = false;
        }
      );
  }
  goBack() {
    this.location.back();
  }

  getInvoice(invoiceNumber: string) {
    this.callStarted();
    this.financeSvc.getInvoiceDetail({ params: { invoiceNumber } }).subscribe(
      (res) => {
        console.log(res);
        this.invoice = res;
        this.currencyCode = res['currencyCode'];
        this.amount = res['amount'];
        this.purpose = res['categoryName'];
        this.description = res['description'];
        // this.initiatePaymentWithInvoiceDetails();
        this.callCompleted();
      },
      (error) => {
        this.callCompleted();
      }
    );
  }

  initiatePaymentWithInvoiceDetails() {
    if (this.invoice && this.noPayment) {
      const body: any = {
        "invoice_number": this.invoice?.invoiceNumber,
        "currency_id": this.invoice?.currencyId,
        "payers_name": this.invoice?.companyName,
        // "payers_phone": this.invoice,
        "payers_email": this.invoice?.customerEmail,
        // "payers_address": this.invoice,
        "invoice_description": this.invoice?.description,
        "description": this.invoice?.description,
        "company_name": this.invoice?.companyName,
        "amount_to_pay": this.invoice?.amount,
        "revenue_service_id": this.invoice?.revenueServiceId,
        "ncc_id": this.invoice?.nccId,
        // "redirection_url": this.invoice
      }

      this.pending = true;
      this.financeSvc.makePayment({body}).subscribe(
        (res) => {
          this.pending = false;
          this.getInvoicePayment(this.invoiceNumber);
        },
        (error) => {
          this.pending = false;
        }
      );
    }
  }

  getConfig(configId: string) {
    this.pending = true;
    this.financeSvc.getPaymentConfig({ configId: configId }).subscribe(
      (res) => {
        this.paymentRedirect = res.value === 'true' ? true : false;
        this.pending = false;
      },
      (error) => {
        this.pending = false;
      }
    );
  }
  // curl --location 'http://finance.showcase.com.ng/api-server/payment/remita-callback/<the internal transaction ref id of the payment>' \
  // --header 'Accept: text/plain'
  getInvoicePayment(invoiceNumber: string) {
    this.callStarted();
    this.financeSvc.getInvoicePayment({ params: { invoiceNumber } }).subscribe(
      (res: any) => {
        console.log(res, 'results');
        this.invoicePayment = res;
        this.rrr = res['transactionRef'];
        this.address = res['paymentDetails']['payers_address'];
        this.name = res['paymentDetails']['payers_name'];
        this.phone = res['paymentDetails']['payers_phone'];
        this.email = res['paymentDetails']['payers_email'];
        this.docPath = res['detailsDocumentPath'];
        this.paymentLink = res['paymentUrl'];
        this.initiatedPaymentId = res['initiatedPaymentId'];
        this.internalTransactionRef = res['internalTransactionRef'];
        this.callCompleted();
      },
      (error: any) => {
        this.financeSvc.getPaymentStatus({ id: this.transactionRef }).subscribe(
          (res: any) => {
            const response = res.payment;
            this.pending = false;
            this.invoicePayment = response;
            this.rrr = response['transactionRef'];
            this.address = response['paymentDetails']['payers_address'];
            this.name = response['paymentDetails']['payers_name'];
            this.phone = response['paymentDetails']['payers_phone'];
            this.email = response['paymentDetails']['payers_email'];
            this.docPath = response['detailsDocumentPath'];
            this.paymentLink = response['paymentUrl'];
            this.initiatedPaymentId = response['initiatedPaymentId'];
            this.internalTransactionRef = response['internalTransactionRef'];
            this.callCompleted();
          },
          (error) => {
            this.pending = false;
            this.callCompleted();
            if (error?.status == 404) {
              this.noPayment = true;
              // this.initiatePaymentWithInvoiceDetails()
            }
            // ;
          }
        );
      }
    );
  }
  success: boolean = false;
  error: boolean = false;
  closeMessage() {
    this.success = false;
    this.error = false;
  }
  callStarted() {
    this.pendingArr.push(true);
  }

  callCompleted() {
    this.pendingArr.pop();
  }

  ngOnInit(): void {
    this.redirectUrl = document.referrer;
    console.log(this.redirectUrl, 'this.previousUrl = document.referrer;');
  }
  generateTransactionID(length = 13) {
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let transactionID = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      transactionID += characters[randomIndex];
    }
    return transactionID;
  }
  makePayment() {
    const transactionId = this.generateTransactionID();
    console.log(transactionId, 'transacionId');
    this.financeSvc.makePayment2(
      transactionId,
      this.rrr,
      this.handleSuccess.bind(this),
      this.handleError.bind(this),
      this.handleClose.bind(this)
    );
  }
  handleSuccess(response: any) {
    console.log('Payment successful:', response);

    this.registerFinance();
    // Custom success handling logic here
    // Example: Redirect to a success page
    // window.location.href = '/payment-success';
  }

  handleError(response: any) {
    console.log('Payment error:', response);
    this.error = true;
    // Custom error handling logic here
    // Example: Show error message to the user
    // alert('Payment failed. Please try again.');
  }

  handleClose() {
    console.log('Payment widget closed');
    document.body.classList.remove('no-scroll');
    document.body.classList.add('scroll');
    console.log(this.internalTransactionRef, 'refnew');
  }
  registerFinance() {
    this.pending = true;
    this.financeSvc
      .financeRemitaCallback({ refId: this.internalTransactionRef })
      .subscribe(
        (res) => {
          console.log(res.status, 'status');
          if (res.status === 200) {
            this.success = true;
            this.paymentComplete = true;
            setTimeout(() => {
              window.open(
                this.systemRedirect
                  ? this.systemRedirect
                  : this.redirectUrl + '?message=Success',
                '_self'
              );
            }, 2000);
          } else {
            this.error = true;
          }
          this.pending = false;
        },
        (error) => {
          console.log(error.status, 'errrrstatus');
          if (error.status === 200) {
            this.success = true;
            this.paymentComplete = true;
            setTimeout(() => {
              window.open(
                this.systemRedirect
                  ? this.systemRedirect
                  : this.redirectUrl + '?message=Success',
                '_self'
              ); // this.router.navigateByUrl(decodeURIComponent(this.redirectUrl));
            }, 2000);
          } else {
            this.error = true;
          }
          this.pending = false;
        }
      );
  }
}
